import { useQuery } from '@tanstack/react-query'
import { UserAPI, WebSocketAPI } from '@/services/api'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

const DashboardHome = () => {
  const { data: balanceSummary, isLoading: balanceLoading } = useQuery({
    queryKey: ['balance-summary'],
    queryFn: UserAPI.getBalanceSummary
  })

  const { data: wsStats, isLoading: wsLoading } = useQuery({
    queryKey: ['websocket-stats'],
    queryFn: WebSocketAPI.getConnectionStats,
    refetchInterval: 30000 // Refresh every 30 seconds
  })

  if (balanceLoading || wsLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  const stats = [
    {
      name: '전체 사용자',
      value: balanceSummary?.data?.summary?.totalUsers || 0
    },
    {
      name: '활성 연결',
      value: wsStats?.data?.total_connections || 0
    },
    {
      name: '총 원화 잔액',
      value: `₩${(balanceSummary?.data?.summary?.totalKrwBalance || 0).toLocaleString()}`
    },
    {
      name: '총 토큰 잔액',
      value: (balanceSummary?.data?.summary?.totalTokenBalance || 0).toLocaleString()
    }
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">대시보드</h1>
        <p className="mt-1 text-sm text-gray-500">
          관리자 대시보드에 오신 것을 환영합니다. 오늘의 현황을 확인하세요.
        </p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div key={stat.name} className="card">
            <div className="card-body">
              <div className="flex items-center">
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-500 truncate">
                    {stat.name}
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stat.value}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* System Status */}
      <div className="card">
        <div className="card-header">
          <h3 className="text-lg font-medium text-gray-900">시스템 상태</h3>
        </div>
        <div className="card-body space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">웹소켓 연결</span>
            <span className="badge-success">
              {wsStats?.data?.total_connections || 0} 활성
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">온라인 관리자</span>
            <span className="badge-info">
              {wsStats?.data?.admin_connections || 0}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">온라인 일반 사용자</span>
            <span className="badge-info">
              {wsStats?.data?.user_connections || 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardHome